import React,{useEffect} from "react";
import "./Footer.css";
import "aos/dist/aos.css";
import AOS from "aos";

import { FaInstagram, FaMailBulk, FaYoutube } from "react-icons/fa";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <footer className="sarathi-footer">
      <div className="logo-section">
        
        <h1 className="footer-brand" data-aos="fade-up">LEPIC</h1>
      </div>

      {/* <ul className="footer-nav">
        <li>Company</li>
        <li>Products</li>
        <li>About</li>
        <li>Contact</li>
      </ul> */}

      <div className="footer-icons" data-aos="fade-right">
        <span><FaInstagram /></span>
        <span><FaYoutube /></span>
        <span><FaMailBulk /></span>
      </div>

      <hr className="footer-line" />

      <p className="footer-credit">
      Copyright © 2025   <span>LePic</span> – All Right Reserved
      </p>
    </footer>
  );
};

export default Footer;
